.trigger {
	display: grid;
	width: 40px;
	height: 40px;
	padding: 0;
	place-items: center;
	border: 2px solid var(--select-ink, #252134);
	color: var(--select-ink, #252134);
	background: #fff;
	cursor: pointer;
}

.trigger:hover,
.trigger:focus-visible {
	color: #fff;
	background: var(--purple, #6558e8);
}

.trigger:active {
	transform: translateY(1px);
}
.trigger svg {
	width: 22px;
	height: 22px;
	fill: none;
	stroke: currentColor;
	stroke-linecap: square;
	stroke-width: 2.4;
}

.error {
	position: fixed;
	z-index: 2100;
	right: 14px;
	bottom: 14px;
	max-width: min(420px, calc(100vw - 28px));
	padding: 10px 12px;
	border: 2px solid #252134;
	color: #252134;
	background: #ffe5ea;
	box-shadow: 4px 4px 0 rgba(37, 33, 52, 0.22);
	font-size: 13px;
	font-weight: 800;
	line-height: 1.4;
}
